import React from 'react'
import { Outlet } from "react-router-dom";
import PrivateLayout from '../../components/layout/Private';

const Dashboard = () =>  (
  <PrivateLayout>
    <Outlet />
  </PrivateLayout>
)

export default Dashboard